import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiMail, FiMapPin } = FiIcons;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    interest: 'I need something built',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you! Your message has been sent to hello@cruciblelab.org');
  };

  return (
    <section className="pt-40 pb-24 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20">
          <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}>
            <span className="text-[#3b82f6] font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Get in Touch</span>
            <h1 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tight uppercase font-montserrat">Let's Build.</h1>
            <p className="text-xl text-[#94a3b8] mb-12 leading-relaxed font-medium">
              Ready to ship your next product? Send a message and let's start the conversation.
            </p>

            <div className="space-y-8">
              <div className="flex items-center space-x-6 group">
                <div className="w-12 h-12 bg-[#2a3658] border border-[#344271] rounded-xl flex items-center justify-center group-hover:border-[#3b82f6]/40 transition-colors">
                  <SafeIcon icon={FiMail} className="text-xl text-[#3b82f6]" />
                </div>
                <span className="text-white font-bold tracking-widest uppercase">hello@cruciblelab.org</span>
              </div>
              <div className="flex items-center space-x-6 group">
                <div className="w-12 h-12 bg-[#2a3658] border border-[#344271] rounded-xl flex items-center justify-center group-hover:border-[#3b82f6]/40 transition-colors">
                  <SafeIcon icon={FiMapPin} className="text-xl text-[#3b82f6]" />
                </div>
                <span className="text-white font-bold tracking-widest uppercase text-sm">Rapid City, South Dakota</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="bg-[#2a3658] p-10 md:p-12 rounded-[40px] border border-[#344271] shadow-2xl">
            <form onSubmit={handleSubmit} className="space-y-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <label className="block text-[#94a3b8] text-[10px] font-black uppercase tracking-[0.2em] mb-3">Your Name</label>
                  <input
                    type="text"
                    required
                    className="w-full bg-[#07113a] border border-[#344271] rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-[#3b82f6] transition-colors font-medium"
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-[#94a3b8] text-[10px] font-black uppercase tracking-[0.2em] mb-3">Email Address</label>
                  <input
                    type="email"
                    required
                    className="w-full bg-[#07113a] border border-[#344271] rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-[#3b82f6] transition-colors font-medium"
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                  />
                </div>
              </div>

              <div>
                <label className="block text-[#94a3b8] text-[10px] font-black uppercase tracking-[0.2em] mb-3">I'm interested in</label>
                <select
                  className="w-full bg-[#07113a] border border-[#344271] rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-[#3b82f6] transition-colors font-bold tracking-widest uppercase text-sm"
                  onChange={(e) => setFormData({...formData, interest: e.target.value})}
                >
                  <option>I need something built</option>
                  <option>I'm interested in AI consulting</option>
                  <option>I'd like to explore your products</option>
                  <option>Press / other</option>
                </select>
              </div>

              <div>
                <label className="block text-[#94a3b8] text-[10px] font-black uppercase tracking-[0.2em] mb-3">Project Details</label>
                <textarea
                  rows="4"
                  required
                  className="w-full bg-[#07113a] border border-[#344271] rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-[#3b82f6] transition-colors font-medium resize-none"
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                ></textarea>
              </div>

              <button className="w-full bg-[#3b82f6] hover:bg-[#2563eb] text-white font-black py-5 rounded-2xl transition-all shadow-xl shadow-[#3b82f6]/20 uppercase tracking-[0.2em] flex items-center justify-center space-x-3">
                <span>Send Message</span>
                <SafeIcon icon={FiSend} />
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;